'use client';
import React from 'react';
import SpecificationTabData from '../../SpecificationTabData';
import WildsLaunchContainer from '../../../WildsLaunchContainer';
export default function Service(props: any) {
  const { t } = props;
  const tabContent = [
    {
      heading: t['serviceContent']['title'],
      description: t['serviceContent']['desc'],
      listElement: t['serviceContent']['list'],
      additional: t['serviceContent']['additionalServices'],
      images: props.tabImages,
    },
  ];
  return (
    <WildsLaunchContainer>
      <SpecificationTabData
        t={t}
        tabs={tabContent}
        tabThemeImageBackground={props.tabThemeImageBackground}
      />
    </WildsLaunchContainer>
  );
}
